import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
    return (
        <div className="privacy-policy">
            <div className="privacy-container">
                <h1>Privacy Policy</h1>
                <p className="last-updated">Last Updated: December 22, 2024</p>

                <section>
                    <h2>1. Introduction</h2>
                    <p>
                        Welcome to Pika Pika AI Video Generator ("we," "our," or "us"). We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application.
                    </p>
                </section>

                <section>
                    <h2>2. Information We Collect</h2>
                    <h3>2.1 Personal Information</h3>
                    <p>We may collect the following personal information:</p>
                    <ul>
                        <li>Email address (when you create an account)</li>
                        <li>Display name and profile photo (optional)</li>
                        <li>User-generated content (images, videos, and text prompts)</li>
                    </ul>

                    <h3>2.2 Automatically Collected Information</h3>
                    <ul>
                        <li>Device information (model, operating system, unique device identifiers)</li>
                        <li>Usage data (app features used, time spent, interactions)</li>
                        <li>Analytics data (crash reports, performance metrics)</li>
                        <li>Advertising identifiers (for personalized ads)</li>
                    </ul>
                </section>

                <section>
                    <h2>3. How We Use Your Information</h2>
                    <p>We use the collected information for:</p>
                    <ul>
                        <li>Providing and maintaining our AI generation services</li>
                        <li>Personalizing your experience</li>
                        <li>Processing your requests and transactions</li>
                        <li>Sending you notifications and updates</li>
                        <li>Improving our app and developing new features</li>
                        <li>Displaying relevant advertisements</li>
                        <li>Analyzing usage patterns and trends</li>
                        <li>Ensuring security and preventing fraud</li>
                    </ul>
                </section>

                <section>
                    <h2>4. Third-Party Services</h2>
                    <p>We use the following third-party services:</p>
                    <ul>
                        <li><strong>Firebase:</strong> For authentication, database, storage, and analytics</li>
                        <li><strong>Google AdMob:</strong> For displaying advertisements</li>
                        <li><strong>AI Service Providers:</strong> For image and video generation</li>
                        <li><strong>Google Sign-In:</strong> For authentication</li>
                    </ul>
                    <p>
                        These services may collect information as described in their respective privacy policies.
                    </p>
                </section>

                <section>
                    <h2>5. Data Storage and Security</h2>
                    <p>
                        We implement appropriate technical and organizational measures to protect your personal information. Your data is stored on secure servers provided by Firebase (Google Cloud Platform). However, no method of transmission over the internet is 100% secure.
                    </p>
                </section>

                <section>
                    <h2>6. User-Generated Content</h2>
                    <p>
                        When you create and share content through our app:
                    </p>
                    <ul>
                        <li>Images and videos you generate are stored in our cloud storage</li>
                        <li>Content you share to the community gallery becomes publicly visible</li>
                        <li>You retain ownership of your creations</li>
                        <li>You can delete your content at any time</li>
                    </ul>
                </section>

                <section>
                    <h2>7. Advertising</h2>
                    <p>
                        We display advertisements through Google AdMob. AdMob may use your advertising identifier and other information to show personalized ads. You can opt out of personalized advertising in your device settings.
                    </p>
                </section>

                <section>
                    <h2>8. Children's Privacy</h2>
                    <p>
                        Our app is not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and believe your child has provided us with personal information, please contact us.
                    </p>
                </section>

                <section>
                    <h2>9. Your Rights</h2>
                    <p>You have the right to:</p>
                    <ul>
                        <li>Access your personal information</li>
                        <li>Correct inaccurate data</li>
                        <li>Delete your account and associated data</li>
                        <li>Opt out of marketing communications</li>
                        <li>Withdraw consent for data processing</li>
                    </ul>
                </section>

                <section>
                    <h2>10. Data Retention</h2>
                    <p>
                        We retain your personal information for as long as your account is active or as needed to provide services. When you delete your account, we will delete your personal information within 30 days, except where we are required to retain it for legal purposes.
                    </p>
                </section>

                <section>
                    <h2>11. International Data Transfers</h2>
                    <p>
                        Your information may be transferred to and processed in countries other than your country of residence. We ensure appropriate safeguards are in place to protect your information.
                    </p>
                </section>

                <section>
                    <h2>12. Changes to This Privacy Policy</h2>
                    <p>
                        We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
                    </p>
                </section>

                <section>
                    <h2>13. Contact Us</h2>
                    <p>
                        If you have any questions about this Privacy Policy, please contact us at:
                    </p>
                    <p className="contact-info">
                        Email: support@pikapika-ai.com
                    </p>
                </section>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
